import React, { Component } from 'react';
import { Link } from "react-router-dom";
import axios from "axios";
import Loading from './Loading';

export default class JobHistory extends Component {
    constructor(props) {
        super(props);

        this.state = {
            stages: [],
            loading: true,
        };
    }

    componentDidMount() {
        this.loadStages();
    }

    loadStages = async () => {
        try {
            this.setState({ loading: true });

            const response = await axios.get('/api/stages');

            if (response.data.success && response.data.stages) {
                this.setState({
                    stages: response.data.stages,
                    loading: false
                });
            } else {
                this.setState({ loading: false });
            }
        } catch (error) {
            console.error("Error loading stages:", error);
            this.setState({ loading: false });
        }
    }

    render() {
        const { stages, loading } = this.state;

        return (
            <>
                {/* Start Job History Area Area */}
                <section className="job-area section-gap-top section-gap-bottom-90">
                    <div className="container">
                        <div className="row d-flex">
                            <div className="col-lg-12">
                                <div className="section-title">
                                    <h2>Historique stages</h2>
                                    <p>
                                        Cette section met en évidence les stages que j'ai déjà effectués.
                                    </p>
                                </div>
                            </div>
                        </div>

                        {loading ? (
                            <div className="row">
                                <div className="col-12">
                                    <Loading variant="dots" size="medium" color="primary" text="Chargement des stages..." />
                                </div>
                            </div>
                        ) : stages.length === 0 ? (
                            <div className="row">
                                <div className="col-12 text-center">
                                    <p>Aucun stage disponible</p>
                                </div>
                            </div>
                        ) : (
                            <div className="row">
                                {stages.map((stage, index) => {
                                    const location = stage.companyAddress
                                        ? stage.companyAddress.split(',').pop().trim()
                                        : '';
                                    const companyLocation = location
                                        ? `${stage.company}, ${location}`
                                        : stage.company;

                                    return (
                                        <div key={stage.id} className="col-lg-6">
                                            <div className="single-job">
                                                <div className="top-sec d-flex justify-content-between">
                                                    <div className="top-left">
                                                        <h4>Stage ({stage.period})</h4>
                                                        <p>{companyLocation}</p>
                                                    </div>
                                                    <div className="top-right">
                                                        <Link
                                                            /* Le slug, pas l'ordre : réordonner les stages dans
                                                               l'admin ne doit pas changer leurs URL. */
                                                            to={`/stage/${stage.slug}`}
                                                            className="primary-btn"
                                                            data-text="Voir"
                                                        >
                                                            {"Voir".split("").map((rows, keys) => <span key={keys}>{rows}</span>)}
                                                        </Link>
                                                    </div>
                                                </div>
                                                <div
                                                    className="bottom-sec wow fadeIn"
                                                    data-wow-duration="2s"
                                                    data-wow-delay={index * 0.2 + 's'}
                                                >
                                                    {stage.description || 'Stage étudiant dans le cadre du BTS SIO.'}
                                                </div>
                                            </div>
                                        </div>
                                    );
                                })}
                            </div>
                        )}
                    </div>
                </section>
                {/* End Job Historyt Area Area */}
            </>
        );
    }
}